import { render, staticRenderFns } from "./detialPage.vue?vue&type=template&id=1a2f9162&scoped=true"
import script from "./detialPage.vue?vue&type=script&lang=js"
export * from "./detialPage.vue?vue&type=script&lang=js"
import style0 from "./detialPage.vue?vue&type=style&index=0&id=1a2f9162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f9162",
  null
  
)

export default component.exports